import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      {/* Top navigation */}
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Categories column */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              Categories
            </h4>
            <div className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          {/* More categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              &nbsp;
            </h4>
            <div className="space-y-2.5">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              Resources
            </h4>
            <div className="space-y-2.5">
              <Link
                to="/"
                className="block text-sm text-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                Home
              </Link>
              <Link
                to="/article/pandabuy-sheet-complete-guide"
                className="block text-sm text-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                Shopping Guide
              </Link>
              <Link
                to="/article/best-pandabuy-spreadsheet-sneakers-2026"
                className="block text-sm text-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                Sneakers Guide
              </Link>
              <Link
                to="/article/how-to-use-pandabuy-spreadsheets"
                className="block text-sm text-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                How to Use
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                Main Store
              </a>
            </div>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              Connect
            </h4>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              Stay updated with the latest pandabuyspreadsheet finds and
              curated collections.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:text-foreground-950 hover:border-foreground-950 transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:text-foreground-950 hover:border-foreground-950 transition-all cursor-pointer"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line"></i>
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:text-foreground-950 hover:border-foreground-950 transition-all cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom brand bar */}
      <div className="border-t border-background-200/70">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <div className="flex items-baseline gap-1">
              <span className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">
                pandabuy.rest
              </span>
              <span className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">
                2026
              </span>
            </div>
            <div className="flex items-center gap-3 mt-2">
              <span className="block w-10 h-0.5 bg-foreground-950"></span>
              <p className="text-xs text-foreground-400 max-w-[420px]">
                Informational website only. No product sales. External links
                not controlled by us. User responsibility notice applies.
              </p>
            </div>
          </div>
          <p className="text-xs text-foreground-400 whitespace-nowrap">
            &copy; 2026 pandabuy.rest. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}